// /frontend/src/services/userService.js
import apiClient from '../utils/apiClient';

const API_URL = `${process.env.REACT_APP_API_URL}/users/admin`;

export const userService = {
  // Get all users
  getUsers: async () => {
    try {
      const response = await apiClient.get(`${API_URL}/list`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || error.message || 'Failed to fetch users');
    }
  },
  
  // Get user by ID
  getUserById: async (id) => {
    try {
      const response = await apiClient.get(`${API_URL}/${id}`);
      return response.data.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || error.message || 'Failed to fetch user');
    }
  },
  
  // Create new user
  createUser: async (userData) => {
    try {
      const response = await apiClient.post(`${API_URL}/create`, userData);
      return response.data.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || error.message || 'Failed to create user');
    }
  },
  
  // Update user
  updateUser: async (id, userData) => {
    try {
      const response = await apiClient.put(`${API_URL}/${id}`, userData);
      return response.data.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || error.message || 'Failed to update user');
    }
  },
  
  // Delete user
  deleteUser: async (id) => {
    try {
      const response = await apiClient.delete(`${API_URL}/${id}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || error.message || 'Failed to delete user');
    }
  },

  // Update user password
  updateUserPassword: async (id, password) => {
    try {
      const response = await apiClient.put(`${API_URL}/${id}/password`, { password });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || error.message || 'Failed to update password');
    }
  }
};